import React from "react";

import { Label } from "~/components/label";
import { cx } from "~/tools/class-variance";

import { useRequiredFormFieldContext } from "./_context";
import styles from "./_form.module.css";

export interface FormLabelProps extends React.ComponentPropsWithoutRef<typeof Label> {
	headless?: boolean;
}

/**
 * The label for a form field. It associates the label with the form field via the htmlFor attribute.
 * It also provides basic styling for the label ensuring nice positioning and font.
 * It can be nested to maintain both styles and granularity of the <label> element.
 */
export const FormLabel = React.forwardRef<React.ElementRef<typeof Label>, FormLabelProps>(
	({ headless, className, children, ...props }, ref) => {
		const { id } = useRequiredFormFieldContext();

		return (
			<Label className={headless ? className : cx(styles.formLabel, className)} htmlFor={id} ref={ref} {...props}>
				{children}
			</Label>
		);
	},
);

if (import.meta.env.DEV) {
	FormLabel.displayName = "FormLabel";
}
